export const worldviews = [
  { key: 'atheist', label: 'Atheist' },
  { key: 'agnostic', label: 'Agnostic' },
  { key: 'muslim', label: 'Muslim' },
  { key: 'hindu', label: 'Hindu' },
  { key: 'buddhist', label: 'Buddhist' },
  { key: 'catholic', label: 'Catholic' },
  { key: 'mormon', label: 'Mormon' },
  { key: 'jw', label: "Jehovah's Witness" },
  { key: 'curious', label: 'Just Curious' }
];

export const modules = [
  {
    id: 'atheist_q1',
    worldviewTags: ['atheist'],
    type: 'question',
    title: 'What would count as good evidence?',
    body: 'Consider what kind of evidence would genuinely move you toward believing in God.'
  },
  {
    id: 'atheist_encounter',
    worldviewTags: ['atheist'],
    type: 'encounter',
    title: 'Conceptual Worship Experiment',
    body: 'Take three minutes to direct admiration toward Truth and Love. If God is real, invite Him to reveal Himself.'
  },
  {
    id: 'atheist_practice',
    worldviewTags: ['atheist'],
    type: 'practice',
    title: 'One Unseen Kindness',
    body: 'Do something kind today that no one else will see. Reflect on how it felt.'
  },
  {
    id: 'muslim_q1',
    worldviewTags: ['muslim'],
    type: 'question',
    title: 'Who is ʿĪsā in your understanding?',
    body: 'Explore the role of Jesus (Isa) in your tradition and what the Gospels claim about Him.'
  },
  {
    id: 'muslim_encounter',
    worldviewTags: ['muslim'],
    type: 'encounter',
    title: 'Guidance Dream',
    body: 'Pray for guidance and keep a journal for seven nights, noting any dreams that offer insight.'
  },
  {
    id: 'muslim_practice',
    worldviewTags: ['muslim'],
    type: 'practice',
    title: 'Secret Charity',
    body: 'Give anonymously to someone in need and reflect on the experience.'
  }
];

export const precepts = [
  {
    key: 'jesusIsChrist',
    title: 'Jesus is the Christ',
    verse: 'John 20:31',
    summary: 'Believe that Jesus is the Messiah, the Son of God.'
  },
  {
    key: 'loveGod',
    title: 'Love God with all your heart',
    verse: 'Matthew 22:37',
    summary: 'Commit to loving God with all that you are.'
  },
  {
    key: 'loveOthers',
    title: 'Love each other',
    verse: 'John 13:34',
    summary: 'Resolve to love others as Jesus loves us.'
  }
];
